import { render, staticRenderFns } from "./ViewCafeteriaPage.vue?vue&type=template&id=b6e640dc"
import script from "./ViewCafeteriaPage.vue?vue&type=script&lang=js"
export * from "./ViewCafeteriaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports